module.exports = {
  DEFAULTCURRENCY: "INR",
  LOGIN: "auth/login",
  REGISTER: "auth/register",
  LOGOUT: "auth/logout",
  REFRESH: "auth/refresh",
  SENDRESETLINK: "auth/sendresetlink",
  RESETPASSWORD: "auth/resetpassword",
  SENDCONFIRMATIONLINK: "auth/sendconfirmationlink",
  REGISTERCOMPANY: "auth/registercompany",
  GETCORPORATESBYPARENTCOMPANYID: "company/getcorporatesbyparent",

  CREATETEMPLATE: "template",
  GETALLTEMPLATES: "template/all",
  GETTEMPLATEPREVIEWDATA: "template/preview-data",

  CREATECOMPANYWALLET: "companywallet",
  GETTOPUPHISTORYBYCOMPANYID: "companywallet/getbycompany",

  GETAllBANKACCOUNTS: "companybankaccount/getallbycompany",
  GETBANKSBYCOMPANYID: "companybankaccount/getbycompany",
  CREATECOMPANYBANK: "companybankaccount",
  UPDATECOMPANYBANK: "companybankaccount",
  DELETECOMPANYBANK: "companybankaccount",

  SAASREGISTER: "company/saasregister",
  SAASACTIVATE: "company/UpdateTaxInformation",
  VERIFYCOMPANY: "auth/verifyemail",
  SUPPLIERREGISTER: "company/supplierregister",
  SUPPLIERACTIVATE: "company/UpdateSupplierInformation",

  CREATESUBSCRIPTION: "Subscription/create",
  CONFIRMSUBSCRIPTION: "Subscription/confirm",
  GETSUBSCRIPTIONBYCOMPANY: "Subscription/company",

  AISUPPLIERGENRATE: "aiitinerary/generate",
  CREATEAIWEBPACKAGE: "aiitinerary/create-website-package",
  GENRATEANDSAVE: "aiitinerary/generate-and-save",
  AISUPPLIERGENRATEANDSAVE: "aiitinerary/supplier-generate-and-save",
  SEARCHFLIGHTALTERNATIVES: "flight/search-alternatives",
  SEARCHHOTELALTERNATIVES: "hotel/search-hotel-alternatives",

  GETCREDITHISTORY: "credithistory/company",
  GETPRICINGPLANS: "connects/pricing",
  RECHARGECONNECTS: "connects/recharge",

  GETUSERSBYCOMPANY: "user/getbycompany",
  GETUSERSBYBRANCH: "user/getbybranch",
  GETSTAFFBYCOMPANY: "User/getstaffbycompany",
  CREATEUSER: "user",
  UPDATEUSER: "user",
  DELETEUSER: "user",
  GETUSERPROFILE: "user/getprofile",
  CHANGEPASSWORD: "user/changepassword",

  GETALLCOMPANIES: "company/getall",
  GETCOMPANIES: "company/get",
  GETCOMPANYBYID: "company/getbyid",
  GETCOMPANYBYUSER: "company/getbyuser",
  GETCOMPANYAGENTS: "company/agents",
  GETALLAGENTBYCOMPANY: "company/getallagents",
  CREATECOMPANYBYSUPERADMIN: "company/createcompanybysuperadmin",
  UPDATECOMPANY: "company",
  UPDATECOMPANYBYSUPERADMIN: "company/updatebysuperadmin",
  DELETECOMPANY: "company",
  CREATEB2BCOMPANY: "company/b2bcreate",
  UPDATEB2BCOMPANY: "company/updateagent",
  UPDATECOMPANYSTATUS: "company/updatestatus",
  UPDATEWHATSAPPNUMBER: "company/updatewhatsappnumber",
  UPDATECOMPANYCHATBOT: "company/updatechatbot",
  CONNECTWHATSSDK: "whatsapp/start-signup",
  WHATSAPPFINISH: "whatsapp/finish-signup",
  WHATSAPPVERIFY: "whatsapp/verify-code",

  GETALLBRANCHES: "branch/getall",
  GETBRANCHES: "branch/get",
  GETBRANCHBYID: "branch/getbyid",
  GETBRANCHBYUSER: "branch/getbyuser",
  GETBRANCHBYCOMPANY: "branch/getbycompany",
  CREATEBRANCH: "branch",
  UPDATEBRANCH: "branch",
  DELETEBRANCH: "branch",

  GETCOMPANYMENUBYCOMPANY: "companymenu/getbycompany",
  CREATECOMPANYMENU: "companymenu",
  UPDATECOMPANYMENU: "companymenu",
  DELETECOMPANYMENU: "companymenu",

  GETCURRENCY: "currency",
  CREATECURRENCY: "currency",
  UPDATECURRENCY: "currency",
  DELETECURRENCY: "currency",

  GETALLSUPPLIERS: "supplier/getall",
  GETSUPPLIERS: "supplier/get",
  GETSUPPLIERBYCOMPANY: "supplier/getbycompany",
  GETALLSUPPLIERSBYCOMPANY: "supplier/getallsuppliersbycompany",
  CREATESUPPLIER: "supplier",
  UPDATESUPPLIER: "supplier",
  DELETESUPPLIER: "supplier",
  // Add this to your APIConfig.js
  GETAPIKEYS: "Supplier/GetAPIKeys",
  GETSUPPLIERKEYSFORCLIENTCOMPANY: "supplier/get-suppliers",

  GETALLLEADSTATUS: "leadstatus/getall",
  GETLEADSTATUS: "leadstatus/get",
  GETLEADSTATUSBYCOMPANY: "leadstatus/getbycompany",
  GETLEADSTATUSBYID: "leadstatus/getbyid",
  CREATELEADSTATUS: "leadstatus",
  UPDATELEADSTATUS: "leadstatus",
  DELETELEADSTATUS: "leadstatus",
  GETLEADSFORCALENDAR: "lead/getbycompanyforcalendar",
  GETLEADDASHBOARD: "lead/getleaddashboard",
  GETLEADSBYIDBYENQUIRYTYPE: "lead/getcompanyleadsbyuser",

  GETALLLEAD: "lead/getall",
  GETLEAD: "lead/get",
  GETLEADBYCOMPANY: "lead/getbycompany",
  GETLEADBYUSER: "lead/getbyuser",
  GETLEADBYID: "lead/getbyid",
  CREATELEAD: "lead",
  GET_LEADS_BY_TAB: "lead/getleadsbytab",
GET_BROADCASTS: "lead/getbroadcasts",
UPDATE_LEAD_STATUS: "lead/updatestatus",
// ... existing keys like GETDMCS, CREATELEAD, UPDATELEAD, DELETELEAD

  GETLEADSBYUSER:"lead/getcompanyleadsbyuser",
  UPDATELEADSTATUS: "lead/updatestatus",
    GETLEADDASHBOARDBYUSER: `lead/getleaddashboardbyuser`,
 SEND_LEAD_CHAT_MESSAGE: "lead/sendmessage",
 GET_LEAD_CHAT: "lead/getchat",




  UPDATELEAD: "lead",
  DELETELEAD: "lead",
  SENDPDF: "packageshare/sendpackageaspdf",
  SENDBULKPDF: "packageshare/sendbulkpackageaspdf",

  GETALLMEETING: "meeting/getall",
  GETMEETING: "meeting/get",
  GETMEETINGBYLEAD: "meeting/getbylead",
  GETMEETINGBYID: "meeting/getbyid",
  CREATEMEETING: "meeting",
  UPDATEMEETING: "meeting",
  DELETEMEETING: "meeting",
  GETUSERCHAT: "WhatsAppChat/userchat",
  FULLLEADREPORT: "meeting/full-lead-report",

  GETALLSOURCE: "source/getall",
  GETSOURCE: "source/get",
  GETSOURCEBYID: "source/getbyid",
  CREATESOURCE: "source",
  UPDATESOURCE: "source",
  DELETESOURCE: "source",

  GETPAYMENTGATEWAYBYCOMPANY: "paymentgateway/getbycompany",
  CREATEPAYMENTGATEWAY: "paymentgateway",
  UPDATEPAYMENTGATEWAY: "paymentgateway",
  DELETEPAYMENTGATEWAY: "paymentgateway",
  MAKEPAYMENT: "payment/process",

  GETPROMOCODEBYCOMPANY: "promocode/getbycompany",
  CREATEPROMOCODE: "promocode",
  UPDATEPROMOCODE: "promocode",
  DELETEPROMOCODE: "promocode",

  SEARCHFLIGHTS: "flight/search",
  REVIEWHFLIGHT: "flight/review",
  BOOKFLIGHT: "flight/book",
  GETUSERFLIGHTBOOKINGS: "flight/getbyuser",
  GETCOMPANYFLIGHTBOOKINGS: "flight/getbycompany",
  GETPARENTCOMPANYFLIGHTBOOKINGS: "flight/getbyparentcompany",
  GETFLIGHTBOOKINGDETAILS: "flight/getbyid",
  CONFIRMHOLDFLIGHTBOOKING: "flight/Confirm-Hold",
  UPDATEFLIGHTBOOKING: "flight/updatebooking",
  FLIGHTSUPPLIERREPORT: "flight/getsupplierreport",

  SEARCHHOTEL: "hotel/search",
  GETHOTELROOMS: "hotel/rooms",
  HOTELREVIEW: "hotel/review",
  BOOKHOTEL: "hotel/book",
  GETUSERHOTELBOOKINGS: "hotel/getbyuser",
  GETHOTELBOOKINGDETAILS: "hotel/getbyid",
  GETCOMPANYHOTELBOOKINGS: "hotel/getbycompany",
  GETPARENTCOMPANYHOTELBOOKINGS: "hotel/getbyparentcompany",
  GETGSTREPORT: "hotel/gstreport",
  MASTERHOTELS:"hotel/master",
    GETCOMPANYHOTELS:"hotel/company-hotels",
  CREATECOMPANYHOTEL: "hotel/company-hotels",
  UPDATEHOTELDATA: "hotel/company-hotels/save",

  GETALLDESTINATIONTYPES: "destinationtype/getall",
  GETDESTINATIONTYPES: "destinationtype",
  CREATEDESTINATIONTYPE: "destinationtype",
  UPDATEDESTINATIONTYPE: "destinationtype",
  GETDESTINATIONTYPEBYID: "destinationtype/getbyid",
  DELETEDESTIONTYPE: "destinationtype",

  GETALLDESTINATIONS: "destination/getall",
  GETDESTINATION: "destination/get",
  GETDESTINATIONBYID: "destination/getbyid",
  GETALLDESTINATIONBYCOMPNAYID: "destination/getallbycompany",
  GETDESTINATIONBYCOMAPANYID: "destination/getbycompany",
  CREATEDESTINATION: "destination",
  UPDATEDESTINATION: "destination",
  DELETEDESTINATION: "destination",
  GETDESTIONBYTYPE: "destination/gettypebycompany",

  GETALLTRAVELTYPES: "traveltype/getall",
  GETTRAVELTYPE: "traveltype",
  CREATETRAVELTYPE: "traveltype",
  UPDATETRAVELTYPE: "traveltype",
  GETTRAVELTYPEBYID: "traveltype/getbyid",
  DELETETRAVELTYPE: "traveltype",

  GETALLPACKAGES: "package/getall",
  GETPACKAGE: "package/get",
  GETPACKAGEBYID: "package/getbyid",
  GETPACKAGEBYCOMAPANYID: "package/getbycompany",
  CREATEPACKAGE: "package",
  UPDATEPACKAGE: "package",
  DELETEPACKAGE: "package",
  GETPACKAGEDETAILS: "package/getpackagedetails",
  CLONEPACKAGE: "package/clone",
  GETPACKAGESBYDESTINATION: "package/getbydestination",
  GETPACKAGESBYSEARCH: "package/getbysearch",
  GETPACKAGESBYUMRAHSEARCH: "package/getbysearchumrah",
  UPDATEPACKAGESTATUS: "package/updatestatus",
  UPDATETOGGLE: "package/togglewebsite",
  GETWEBSITEPACKAGES: "package/getwebsitepackagesbycompany",

  GETALLPACKAGEFLIGHT: "pacakgeflightbooking/getall",
  GETPACKAGEFLIGHT: "packageflightbooking/get",
  GETPACKAGEFLIGHTBYID: "pacakgeflightbooking/getbyid",
  GETFLIGHTBYPACKAGEID: "packageflightbooking/getflightbypackageid",
  CREATEPACKAGEFLIGHT: "packageflightbooking",
  UPDATEPACKAGEFLIGHT: "packageflightbooking",
  DELETEPACKAGEFLIGHT: "packageflightbooking",

  GETALLPACKAGEHOTEL: "pacakgebooking/getall",
  GETPACKAGEHOTEL: "packagehotelbooking/get",
  GETPACKAGEHOTELBYID: "pacakgehotelbooking/getbyid",
  GETHOTELBYPACKAGEID: "packagehotelbooking/gethotelbypackageid",
  CREATEPACKAGEHOTEL: "packagehotelbooking",
  UPDATEPACKAGEHOTEL: "packagehotelbooking",
  DELETEPACKAGEHOTEL: "packagehotelbooking",

  GETALLPACKAGESIGHT: "pacakgesightseeing/getall",
  GETPACKAGESIGHT: "packagesightseeing/get",
  GETPACKAGESIGHTBYID: "pacakgesightseeing/getbyid",
  GETSIGHTBYPACKAGEID: "packagesightseeing/getsightseeingbypackageid",
  CREATEPACKAGESIGHT: "packagesightseeing",
  UPDATEPACKAGESIGHT: "packagesightseeing",
  DELETEPACKAGESIGHT: "packagesightseeing",

  GETALLPACKAGEINCLUDES: "packageinclude/getall",
  GETPACKAGEINCLUDE: "packageinclude/get",
  GETALLPACKAGEINCLUDEBYID: "packageinclude/getbyid",
  GETINCLUDEBYPACKAGEID: "packageinclude/getincludebypackageid",
  CREATEPACKAGEINCLUDE: "packageinclude",
  UPDATEPACKAGEINCLUDE: "packageinclude",
  DELETEPACKAGEINCLUDE: "packageinclude",

  GETALLPACKAGEEXCLUDES: "packageexclude/getall",
  GETPACKAGEEXCLUDE: "packageexclude/get",
  GETALLPACKAGEEXCLUDEBYID: "packageexclude/getbyid",
  GETEXCLUDEBYPACKAGEID: "packageexclude/getexcludebypackageid",
  CREATEPACKAGEEXCLUDE: "packageexclude",
  UPDATEPACKAGEEXCLUDE: "packageexclude",
  DELETEPACKAGEEXCLUDE: "packageexclude",

  GETALLTERMS: "packagetermsandcondition/getall",
  GETPACKAGETERMS: "packagetermsandcondition/get",
  GETALLPACKAGETERMSBYID: "packagetermsandcondition/getbyid",
  GETTERMSBYPACKAGEID: "packagetermsandcondition/gettermsbypackageid",
  CREATEPACKAGETERMS: "packagetermsandcondition",
  UPDATEPACKAGETERMS: "packagetermsandcondition",
  DELETEPACKAGETERMS: "packagetermsandcondition",

  GETALLTRANSFERS: "pacakgetransfer/getall",
  GETPACKAGETRANSFER: "pacakgetransfer/get",
  GETALLPACKAGETRANSFERBYID: "pacakgetransfer/getbyid",
  GETTRANSFERBYPACKAGEID: "pacakgetransfer/gettransferbypackageid",
  CREATEPACKAGETRANSFER: "pacakgetransfer",
  UPDATEPACKAGETRANSFER: "pacakgetransfer",
  DELETEPACKAGETRANSFER: "pacakgetransfer",

  GETALLITINERAIES: "packageitinerary/getall",
  GETPACKAGEITINERARY: "packageitinerary/get",
  GETALLPACKAGEITINERARYBYID: "packageitinerary/getbyid",
  GETITINERARYBYPACKAGEID: "packageitinerary/getitinerarybypackageid",
  CREATEPACKAGEITINERARY: "packageitinerary",
  UPDATEPACKAGEITINERARY: "packageitinerary",
  DELETEPACKAGEITINERARY: "packageitinerary",

  GETALLCUSTOMERS: "customer/getall",
  GETCUSTOMERS: "customer/get",
  GETCUSTOMERBYID: "customer/getbyid",
  GETCUSTOMERBYCOMAPANYID: "customer/getbycompany",
  CREATECUSTOMER: "customer",
  UPDATECUSTOMER: "customer",
  DELETECUSTOMER: "customer",
  GETALLCUSTOMERSBYCOMPANYID: "customer/getallbycompanyid",

  MARKETING: "marketing/sendcampaign",

  SIGHTSEEINGPRODUCTS: "sightseeing/getproducts",
  SIGHTSEEINGPRODUCT: "sightseeing/getproduct",
  SIGHTSEEINGBOOK: "sightseeing/book",
  GETSIGHTSEEINGBOOKINGDETAILS: "sightseeing/getbyid",
  GETPARENTCOMPANYSIGHTSEEINGBOOKINGS: "sightseeing/getbyparentcompany",
  SIGHTSEEINGCHECKAVAILABILITY: "sightseeing/checkavailability",
  GETSIGHTSEEINGFORADMIN: "sightseeing/admin",
  UPDATESIGHTSEEINGBYADMIN: "sightSeeing/updatebooking",

  GETALLORIGIN: "fromorigin/getall",
  GETORIGIN: "fromorigin/get",
  GETORIGINBYID: "fromorigin/getbyid",
  GETALLORIGINBYCOMPANYID: "fromorigin/getallbycompany",
  GETORIGINBYCOMPANYID: "fromorigin/getbycompany",
  CREATEORIGIN: "fromorigin",
  UPDATEORIGIN: "fromorigin",
  DELETEORIGIN: "fromorigin",

  GETALLPACKAGEDATE: "packagedate/getall",
  GETPACKAGEDATE: "packagedate/get",
  GETPACKAGEDATEBYID: "packagedate/getbyid",
  GETALLPACKAGEDATEBYCOMPANY: "packagedate/getallbycompany",
  GETPACKAGEDATEBYCOMPANYID: "packagedate/getbycompany",
  CREATEPACKAGEDATE: "packagedate",
  UPDATEPACKAGEDATE: "packagedate",
  DELETEPACKAGEDATE: "packagedate",
  GETDATESBYTYPE: "packagedate/getdatesbytypeandcompany",

  GETALLPACKAGEENQUIRY: "packageenquiry/getall",
  GETPACKAGEENQUIRYBYID: "packageenquiry/getbyid",
  GETPACKAGEENQUIRYBYCOMPANYID: "packageenquiry/getbycompany",
  CREATEPACKAGEENQUIRY: "packageenquiry",
  UPDATEPACKAGEENQUIRY: "packageenquiry",
  DELETEPACKAGEENQUIRY: "packageenquiry",
  GETENQUIRYBYTYPE: "packageenquiry/getbytypeandcompany",

  GETLANDINGBYCOMPANY: "landingpage/getbyCompany",
  UPDATELANDINGPAGE: "landingpage",

  CREATEBOOKINGREQUEST: "groupbooking",
  GETAGENTBOOKING: "groupbooking/getbyagent",
  GETADMINBOOKING: "groupbooking/getbyadmin",
  DELETEBOOKINGREQUEST: "groupbooking",
  UPDATEBOOKINGREQUEST: "groupbooking/updatestatus",
  GETBOOKINGBYID: "groupbooking",

  GETDASHBOARD: "dashboard",

  GETAPPLICANTSBYPACKAGE: "packageapplicant/getbypackage",
  GETAPPLICANTBYID: "packageapplicant/getbyId",
  CREATEAPPLICANT: "packageapplicant",
  UPDATEAPPLICANT: "packageapplicant",
  DELETEAPPLICANT: "packageapplicant",
  DELETEAPPLICANTDOCUMENT: "packageapplicant/document",

  GETALLPROMOTIONS: "promotion/getall",
  GETPROMOTIONS: "promotion/get",
  GETPROMOTIONBYID: "promotion/getbyid",
  GETPROMOTIONBYUSER: "promotion/getbyuserid",
  CREATEPROMOTION: "promotion",
  UPDATEPROMOTION: "promotion",
  DELETEPROMOTION: "promotion",
  SENDPROMOTIONWHATSAPP: "promotion/send",


 GETCOUNTRIES:"VisaMaster/countries",
GETB2BVISAS:"VisaMaster/visaB2Bprices",


  GETVISAREQUESTS: "visarequest/get",
  GETVISAREQUESTSFORAGENTS:"visarequest/getforagent",
  GETVISAREQUESTBYID: "visarequest/getbyid",
  GETVISAREQUESTREPORTBYCOMPANY: "visarequest/getvisareportbycompany",
  GETVISASUPPLIERREPORT: "visarequest/getvisasupplierreport",
  SENDVISATOSUPPLIER: "visarequest/send",
  CREATEVISAREQUEST: "visarequest",
  UPDATEVISAREQUEST: "visaRequest",
  UPDATEVISASTATUS: "visaRequest/UpdateStatus",
  UPDATEVISAMARKUP: "visaRequest/updatepricing",
  DELETEVISAREQUEST: "visaRequest",

  GETVISAAPPLICANTSBYREQUEST: "visaapplicant",
  GETVISAREQUESTSBYSUPPLIER: "visaapplicant/supplier",
  CREATEVISAAPPLICANT: "visaapplicant",
  UPDATEVISAAPPLICANT: "visaapplicant",
  DELETEVISAAPPLICANT: "visaapplicant",
  UPDATEAPPLICANTSTATUSANDFILE: "visaApplicant/updateapplicantstatus",
  UPDATEVISAREQUESTPRICING: "visaapplicant/updatepricing",

  DELETEVISAAPPLICANTDOCUMENT: "visaapplicant/delete-document",

  // Other endpoints
  GETALLSUPPLIERVISAPRICES: "suppliervisaprice/getall",
  GETSUPPLIERVISAPRICESBYSUPPLIERID: "suppliervisaprice/getbysupplier",
  GETSUPPLIERVISAPRICESBYVISAID: "suppliervisaprice/getbyvisa",
  GETBESTPRICEBYVISAID: "SupplierVisaPrice/getbestprice",
  CREATESUPPLIERVISAPRICE: "suppliervisaprice",
  UPDATESUPPLIERVISAPRICE: "suppliervisaprice",
  DELETESUPPLIERVISAPRICE: "suppliervisaprice",

  GETALLVISAAPPOINTMENTS: "VisaAppointment/GetAll",
  GETVISAAPPOINTMENTSBYSUPPLIER: "VisaAppointment/GetBySupplier",
  CREATEVISAAPPOINTMENT: "VisaAppointment/Create",
  UPDATEVISAAPPOINTMENT: "VisaAppointment/Update",
  DELETEVISAAPPOINTMENT: "VisaAppointment",

  SEARCHBUSES: "bus/search",
  GETBUSSEATS: "bus/seats",
  GETBUSBOOKINGBYID: "bus/getbooking",
  BOOKBUSSEATS: "bus/bookbusticket", // This will be for direct booking
  BLOCKBUSSEATS: "bus/blockbusticket", // New: Only block seats
  CONFIRMBLOCKEDBOOKING: "bus/blockandbookbusticket", // New: Book blocked seats
  GETBUSBOOKINGS: "bus/getbookings",
  GETCOMPANYBUSBOOKINGS: "/bus/getcompanybookings",
  GETPARENTCOMPANYBUSBOOKINGS: "bus/getbyparentcompany",

  CREATEHOLIDAY: "holiday/generate",
  FLIGHTSUPPLIERREPORT: "flight/getsupplierreport",
  GETFLGIHTREPORTBYCOMPANYID: "flight/getbycompanyreport",
  GETHOLIDAYBYID: "holiday",
  UPDATEHOLIDAY: "holiday/update",
  GETHOLIDAYSBYCOMPANYID: "holiday/getbycompany",
  DELETEHOLIDAY: "holiday",

  CREATEFAQCATEGORY: "faqcategory",
  UPDATEFAQCATEGORY: "faqcategory",
  DELETEFAQCATEGORY: "faqcategory",
  GETALLFAQCATEGORY: "faqcategory/getall",

  CREATEFAQ: "faq",
  UPDATEFAQ: "faq",
  DELETEFAQ: "faq",
  GETALLFAQ: "faq/getall",

  GETALLACCOUNTTYPES: "accounttype/getall",
  GETACCOUNTTYPES: "accounttype/get",
  GETACCOUNTTYPEBYID: "accounttype/getbyid",
  CREATEACCOUNTTYPE: "accounttype",
  UPDATEACCOUNTTYPE: "accounttype",
  DELETEACCOUNTTYPE: "accounttype",

  GETALLACCOUNTS: "account/getall",
  GETALLACCOUNTBYINDUSTRY: "account/getaccountbyindustry",
  GETACCOUNTS: "account/get",
  GETACCOUNTBYID: "account/getbyid",
  CREATEACCOUNT: "account",
  UPDATEACCOUNT: "account",
  DELETEACCOUNT: "account",

  GETALLITEMSBYUSER: "item/getallitemsbyuser",
  GETITEMSBYUSER: "item/getitemsbyuser",
  GETITEMSBYACCOUNTTYPE: "item/getitemsbyaccounttype",
  CREATEITEM: "item",
  UPDATEITEM: "item",
  DELETEITEM: "item",

  GETACCOUNTITEMSBYUSER: "accountitem/getaccountitemsbyuser",
  CREATEACCOUNTITEM: "accountitem",
  UPDATEACCOUNTITEM: "accountitem",
  DELETEACCOUNTITEM: "accountitem",

  GETINVOICEBYID: "invoice/getbyid",
  GETINVOICEBYUSER: "invoice/getbyuser",
  CREATEINVOICE: "invoice",
  UPDATEINVOICE: "invoice",
  DELETEINVOICE: "invoice",
  INVOICESUMMARY: "invoice/getinvoicesummary",
  GETSERIALNUMBER: "invoice/serialnumber",
  GENERATEINVOICENUMBER: "invoice/generateinvoicenumber",

  GETALLTAXRATESBYUSER: "taxrate/getalltaxratesbyUser",
  GETTAXRATEBYUSER: "taxrate/gettaxratesbyUser",
  CREATETAXRATE: "taxrate",
  UPDATETAXRATE: "taxrate",
  DELETETAXRATE: "taxrate",

  GETCHEQUEBYUSER: "cheque/getbyuser",
  CREATECHEQUE: "cheque",
  UPDATECHEQUE: "cheque",
  DELETECHEQUE: "cheque",
  CHEQUESUMMARY: "cheque/getchequecount",

  GETMARKUPBYCOMPANYID: 'companymarkup/getbycompany',
  CREATEMARKUP: 'companymarkup',
  UPDATEMARKUP: 'companymarkup',

   CREATEDMCPACKAGE: 'dmc/packages/create',
  UPDATEDMCPACKAGE: 'dmc/packages',
  GETALLDMCPACKAGES: 'dmc/packages',
  DELETEDMCPACKAGE: 'dmc/packages',
  GETDMCPACKAGEBYID: 'dmc/packages',
  GETALLDMCDEALS: 'dmc/packages/dmcdeals',
  GETDMCPACKAGESBYCOMPANYID: 'dmc/packages/by-company', 
  UPDATEDMCPACKAGESTATUS: "dmc/packages",

  SEARCHINVOICENUMBER: "invoicereports/invoicenumbersearch",
  SALESREPORT: "invoicereports/sales-by-item",
  PURCHASESREPORT: "invoicereports/purchases-by-item",
  INVOICEREPORT: "invoicereports/invoices",
  EXPENSEREPORT: "invoicereports/expense-invoices",
  PROFITLOSSREPORT: "invoicereports/profit-loss",
  PROFITLOSSACCOUNTWISEREPORT: "invoicereports/profit-loss-accountwise",

  GETSERIESFARES: "series-fares",
  SERIESFARESEARCH: "series-fares/agent-search",
  GETROUTESFROM: "series-fares/routes/from",
  CREATESERIESFAREBULK: "series-fares/bulk", // Add this
  DELETESERIESFARE: "series-fares",
  GETSERIESFARESBYCOMPANY: "series-fares",
  SERIESBOOKINGCREATE: "series-bookings/create",
GETAGENTBOOKINGS: "series-bookings/agent",
SERIESBOOKINGSREQUESTS:"series-bookings/dmc",
SERIESBOOKINGSTATUS:"series-bookings/update-booking-status",


  GETOUTINGSBYPARENTCOMPANYID: "corporate/outings/byparentid",
  CREATEOUTING: "corporate/outings",
  GETOUINGSBYCOMPANYID: "corporate/outings/history",
  GETOUTINGCHATBYID: "corporate/outings/chat",
  CREATECHATMESSAGE: "corporate/outings/message",

  GETGROUPTOURSBYPARENTCOMPANYID: "corporate/grouptours/byparentid",
  GETGROUPTOURSBYCOMPANYID: "corporate/grouptours/history",
  CREATEGROUPTOUR: "corporate/grouptours/create",
  GETGROUPTOURCHATBYID: "corporate/grouptours/chat",
  SENDGROUPTOURMESSAGE: "corporate/grouptours/message",
  ADDTRAVELLER: "corporate/grouptours/add-traveller",

  GETMONGOINVOICEBYID: "mongoaccouting/invoices",
  GETMONGOLEDGERSBYID: "mongoaccouting/ledgers",
  GET_PL_REPORT: "mongoaccouting/profit-loss",
  GETPLDETAILEDREPORT: "mongoaccouting/profit-loss-detailed",

  GETDMCS: "Company/DMCs",
  GETINVOICESBYCOMPANYID: "invoice/getbycompanyid",
  SETTLEPAYMENT: "mongoaccouting/settle-payment", 
  GETGSTREPORT: "mongoaccouting/gst-report",
  GETSTATEMENT: "mongoaccouting/statement",
  SETTLESUPPLIERPAYMENT: "mongoaccouting/supplier-payment",
  SETTLEGSTPAYMENT: "mongoaccouting/gst-payment",
  GETINVOICEHISTORY: "mongoaccouting/invoice-history",
  GETMONGOACCOUNTINGDASHBOARD: "mongoaccouting/dashboard",

  GET_ALL_VISAS: "visamaster",
  GET_VISA_BY_ID: "visamaster",
  UPDATE_VISA_MASTER: "visamaster",
  DELETE_VISA_MASTER: "visamaster",


   ASSIGNTEMPLATE: "template/assign-to-company",
  GETCOMPANYTEMPLATEBYTENANT: "template/by-tenant",
  GETTEMPLATEBYCOMPANYID: "template/by-company",
  GETTEMPLATEBYCOMPANYIDFOREDIT: "template/edit",



   GETALLEMPLOYEES: "Employee/Get",
  GETEMPLOYEEBYCOMPANY: "Employee/GetByCompany", 
  CREATEEMPLOYEE: "Employee",
  UPDATEEMPLOYEE: "Employee",
  DELETEEMPLOYEE: "Employee",

  GET_EMPLOYEE_DOCUMENTS: "/EmployeeDocument", // + /{employeeId}
CREATE_EMPLOYEE_DOCUMENTS: "/EmployeeDocument",
UPDATE_EMPLOYEE_DOCUMENT: "/EmployeeDocument",
DELETE_EMPLOYEE_DOCUMENT: "/EmployeeDocument",

GET_EMPLOYEE_DOCUMENTS: "/EmployeeDocument", // + /{employeeId}
CREATE_EMPLOYEE_DOCUMENTS: "/EmployeeDocument",
UPDATE_EMPLOYEE_DOCUMENT: "/EmployeeDocument",
DELETE_EMPLOYEE_DOCUMENT: "/EmployeeDocument",

};
